import React, { useState, useEffect } from "react";

const InfoPersonnelle = ({
  matricule,
  setMatricule,
  nom,
  setNom,
  prenom,
  setPrenom,
  telephone,
  setTelephone,
  annee_participation,
  setAnneeParticipation,
  Rechercher,
}) => {
  const [Info_personnelle, setInfoPersonnelle] = useState({});
  const [Liste_annee_participation, setListeAnneeParticipation] = useState([]);
  const ListChoixAn = () => {
    let List_An = [];
    let i = 1965;
    for (i = 1980; i <= 2026; i++) {
      List_An.push(i);
    }
    return List_An;
  };
  useEffect(() => {
    setListeAnneeParticipation(ListChoixAn());
  }, []);
  return (
    <div class="container">
      <div className="row mb-2">
        <div className="col-12">
          {/* <div className="col-10 mt-2"> */}
          <div class="form-group ">
            <select
              id="Annee_participation"
              className="form-control"
              name="Annee_participation"
              value={annee_participation}
              onChange={(e) => setAnneeParticipation(e.target.value)}
            >
              <option selected>Année de Participation 1</option>

              {Liste_annee_participation.map((l) => (
                <option value={l}>{l}</option>
              ))}
            </select>
          </div>
          {/* <select
            className="form-select form-select-sm"
            aria-label=".form-select-sm example"
          >
            <option selected>Année de Participation</option>

            {Liste_annee_participation.map((l) => (
              <option value={l}>{l}</option>
            ))}
          </select> */}
          {/* </div> */}

          <div className="mb-3 mt-3">
            <input
              type="text"
              className="form-control"
              id="matricule"
              placeholder="Matricule"
              name="matricule"
              value={matricule}
              autoComplete="off"
              onChange={(e) => setMatricule(e.target.value)}
            />
          </div>
          <div className="mb-3 mt-3">
            <input
              type="text"
              className="form-control"
              id="nom"
              placeholder="Nom de Famille"
              name="nom"
              value={nom}
              autoComplete="off"
              onChange={(e) => setNom(e.target.value)}
            />
          </div>
          {/* Prenom */}
          <div className="mb-3 mt-3">
            <input
              type="text"
              className="form-control"
              id="prenom"
              placeholder="Prenom"
              name="prenom"
              value={prenom}
              autoComplete="off"
              onChange={(e) => setPrenom(e.target.value)}
            />
          </div>

          {/* Telephone */}
          <div className="mb-3 mt-3">
            <input
              type="text"
              className="form-control"
              id="telephone"
              placeholder="Telephone"
              name="telephone"
              value={telephone}
              autoComplete="off"
              onChange={(e) => setTelephone(e.target.value)}
            />
          </div>
          {/* <div class="mb-3 mt-3">
            <label for="email" className="form-label">
              Email:
            </label>
            <input
              type="email"
              class="form-control"
              id="email"
              placeholder="Enter email"
              name="email"
            />
          </div> */}
          <div class="d-grid gap-2 col-8 mx-auto">
            <button class="btn btn-primary" type="button" onClick={Rechercher}>
              Rechercher
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPersonnelle;
